import { Client } from '../_classes/list/client';

export let Clients: Client[] = [
  {
    id: 11,
    snils: '12345678901',
    fam: null,
    im: 'Ваня',
    ot: 'Сидорович',
    birthday: null,
    street_id: null,
    street: null,
    dom: null,
    korp: null,
    kv: null,
    reason_id: 1,
    user_id: 1,
    user: 'A.A. Администратор',
    dt: null,
    userm_id: 1,
    userm: 'A.A. Администратор',
    dtm: null
  },
  {
    id: 12,
    snils: '10234567890',
    fam: null,
    im: 'Даша',
    ot: 'Сидорович',
    birthday: null,
    street_id: null,
    street: null,
    dom: null,
    korp: null,
    kv: null,
    reason_id: 1,
    user_id: 1,
    user: 'A.A. Администратор',
    dt: null,
    userm_id: 1,
    userm: 'A.A. Администратор',
    dtm: null
  },
  {
    id: 13,
    snils: '10334567890',
    fam: null,
    im: 'Митя',
    ot: 'Петрович',
    birthday: null,
    street_id: null,
    street: null,
    dom: null,
    korp: null,
    kv: null,
    reason_id: 0,
    user_id: 1,
    user: 'A.A. Администратор',
    dt: null,
    userm_id: 1,
    userm: 'A.A. Администратор',
    dtm: null
  },
  {
    id: 14,
    snils: '10234557890',
    fam: null,
    im: 'Эдик',
    ot: 'Васевич',
    birthday: null,
    street_id: null,
    street: null,
    dom: null,
    korp: null,
    kv: null,
    reason_id: 2,
    user_id: 1,
    user: 'A.A. Администратор',
    dt: null,
    userm_id: 1,
    userm: 'A.A. Администратор',
    dtm: null
  },
  {
    id: 15,
    snils: '90234567890',
    fam: null,
    im: 'Яночка',
    ot: 'Викторовна',
    birthday: null,
    street_id: null,
    street: null,
    dom: null,
    korp: null,
    kv: null,
    reason_id: 3,
    user_id: 2,
    user: 'A.A. Пользователь',
    dt: null,
    userm_id: 2,
    userm: 'A.A. Пользователь',
    dtm: null
  },
]



// WEBPACK FOOTER //
// /usr/home/rob/Staxi/client/src/app/_mock/clients.ts